// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__ABTestingCampaignManagement .BC-Filters .BC-Filters-ConnectedFilterControl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 0.75rem;
  border-bottom: var(--p-border-divider);
}

.BC-Page__ABTestingCampaignManagement .BC-Filters .Polaris-Tabs__Wrapper {
  border-bottom: none;
}

.BC-Page__ABTestingCampaignManagement .BC-Filters .search {
  width: 300px;
}

.BC-Page__ABTestingCampaignManagement .BC-Filters-ConnectedFilterControl__LeftContainer {
  flex: 1 1 auto;
}

.BC-Page__ABTestingCampaignManagement
  .BC-Filters-ConnectedFilterControl__LeftContainer
  .Polaris-Tabs__Wrapper
  #none {
  display: none;
}

.BC-Page__ABTestingCampaignManagement .BC-Filters-ConnectedFilterControl__RightContainer {
  flex: 2 1 auto;
  display: flex;
  align-items: center;
  justify-content: end;
}

.BC-EmptySearch__ABTestingCampaign > p {
  color: #6d7175;
}

.ab-testing-campaign-table .feature-type {
  display: flex;
  padding: 1rem 0;
  cursor: pointer;
}

.ab-testing-campaign-table .feature-type-title {
  font-weight: 600;
  display: flex;
}

.ab-testing-campaign-table .feature-type-title .Polaris-Icon {
  margin: 0 0.5rem 0 0.25rem;
}

.ab-testing-campaign-table thead {
  background: var(--surface-subdued, #fafbfb);
}

.ab-testing-campaign-table thead tr td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid var(--border-divider, #e1e3e5);
}

.ab-testing-campaign-table thead tr td {
  border-top: 1px solid var(--border-divider, #e1e3e5);
  border-bottom: 1px solid var(--border-divider, #e1e3e5);
}

.ab-testing-campaign-table thead tr td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid var(--border-divider, #e1e3e5);
}

.ab-testing-campaign-table .Polaris-DataTable__Cell > p {
  word-break: break-all;
  overflow-wrap: break-word;
  white-space: normal;
}

.BC-Page__ABTestingCampaignManagement .pfs-feature-lock-card {
  padding-bottom: 50px;
}

.ab-testing-campaign-table .Polaris-DataTable__Cell--status,
.ab-testing-campaign-table .Polaris-DataTable__Cell--views {
  text-align: center;
}

.ab-testing-campaign-table .Polaris-DataTable__Cell--actions .btn-launch button {
  color: var(--p-action-primary);
  border-color: var(--p-action-primary);
}

.ab-testing-campaign-table .Polaris-DataTable__Cell--actions .Polaris-Icon svg {
  fill: var(--p-icon);
}

.BC-AB-testing-tour .image {
  background-color: #f7fdfc;
}

.BC-AB-testing-tour .image img {
  width: auto;
  height: 200px;
  padding: 16px;
}

.BC-AB-testing-tour .image {
  display: flex;
  justify-content: center;
}

.BC-AB-testing-tour .action-tour {
  display: flex;
  justify-content: end;
  padding: 0 16px 16px;
}

.BC-AB-testing-tour .heading-tour {
  display: flex;
  justify-content: space-between;
}

/* AB testing - add new merchandising campaign */
.ABTesting-Campaign__GeneralSettings .settings {
  display: flex;
  gap: 24px;
  flex-direction: column;
}

.ABTesting-Campaign__GeneralSettings .settings .content button .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  width: 15px;
  height: 15px;
}

.ABTesting-Campaign__GeneralSettings .settings .content {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ABTesting-Campaign__GeneralSettings .targeting-settings {
  display: flex;
  flex: 1 1 auto;
  gap: 12px;
}

.ABTesting-Campaign__GeneralSettings .targeting-settings > div:first-child {
  width: 30%;
}

.ABTesting-Campaign__GeneralSettings .targeting-settings > div:last-child {
  width: 70%;
}

.ABTesting-Campaign__GeneralSettings .targeting-settings .Polaris-Tag {
  padding-right: unset;
}

.ABTesting-Campaign__GeneralSettings .Polaris-ChoiceList__Choices {
  display: flex;
  flex: 1 auto;
  gap: 32px;
}

/* Variant and traffic */

/* ------- variant version--------- */
.ABTesting__VariantAndTraffic-Merchandising .config-sidebar {
  background: #ffffff;
  width: 25%;
}

.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .Polaris-Icon {
  margin: unset;
}
.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .title {
  font-size: 16px;
  display: flex;
  gap: 6px;
  align-items: center;
}

.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .title > p {
  font-weight: 600;
}

.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .title .point {
  width: 10px;
  height: 10px;
  border-radius: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising .config-sidebar > div {
  border-bottom: 1px solid #e1e3e5;
  padding: 16px;
}

.ABTesting__VariantAndTraffic-Merchandising .config-sidebar .variants {
  padding: unset;
}

.ABTesting__VariantAndTraffic-Merchandising .config-sidebar .variants .heading {
  padding: 16px;
}
.ABTesting__VariantAndTraffic-Merchandising .config-sidebar .variants .card-section {
  padding: 0 16px 16px;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy > div {
  min-height: 1000px;
}

.ABTesting__VariantAndTraffic-Merchandising .Polaris-FullscreenBar {
  position: fixed;
  width: 100%;
  top: 0;
}
.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body {
  display: flex;
  justify-content: space-between;
  height: 100vh;
  min-height: 1040px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .strategy-content {
  margin: 0 10px;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .banner-group-settings {
  padding: 10px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .strategy-content
  .card-section {
  padding: 0px 20px 5px 0px;
  width: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .card-banner-section
  > div
  > div {
  display: grid;
  gap: 20px;
}
.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .card-section {
  padding: 0 !important;
}

.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-title {
  margin-top: 0px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
}

.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-title .title {
  display: flex;
  gap: 3px;
  font-size: 12px;
  font-weight: 500;
  color: #6d7175;
}

.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-settings {
  padding: 12px;
  border-radius: 8px;
  background-color: #f6f6f7;
}

.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-image .Polaris-Link {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  margin-top: 5px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .banner-group-settings
  .banner-image
  .Polaris-Link
  .Polaris-Icon {
  margin: unset;
}
.ABTesting__VariantAndTraffic-Merchandising
  .banner-group-settings
  .banner-settings
  > div:not(:first-child) {
  margin-top: 16px;
}
.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-image > p:last-child {
  font-size: 12px;
  line-height: 16px;
  margin-top: 5px;
  color: #6d7175;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .merchandising-strategies {
  margin-top: 15px;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy {
  background-color: #ffffff;
  width: 30%;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy .card-section {
  padding: 16px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .Polaris-Tabs__TabContainer {
  flex: unset;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .card-section:last-child,
.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .card-section:last-child {
  box-shadow: unset;
}
.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .card-section > p {
  font-size: 14px;
  line-height: 20px;
  margin-top: 2px;
  margin-bottom: 1px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .wrap-attribute {
  display: flex;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .last-or-connector {
  border-bottom: 1px solid #a4e8f2;
  margin-bottom: 30px;
}
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .or-text
  .Polaris-TextStyle--variationStrong {
  height: 20px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 10px;
  background-color: #a4e8f2;
}
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .group-number {
  width: auto;
  min-width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid rgba(201, 204, 207, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  font-size: 12px;
  color: rgba(109, 113, 117, 1);
  line-height: 16px;
  font-weight: 500;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .or-connector {
  width: 10px;
  margin-left: 10px;
  border-left: 1px solid #a4e8f2;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .wrap-attribute
  .first-connector {
  border-top: 1px solid #a4e8f2;
  margin-top: 15px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-strategy
  .card-add-field-attribute
  .or-connector {
  border-bottom: 1px solid #a4e8f2;
  margin-bottom: 20px;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-settings .set-rule-conditions > div,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-settings
  .set-rule-conditions
  > div {
  padding-top: 16px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-settings
  .set-rule-conditions
  .default-text-style {
  font-weight: 400 !important;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-settings
  .set-rule-conditions
  .premium-badge-crown {
  display: flex;
  gap: 4px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-settings
  .set-rule-conditions
  .premium-badge-crown
  .Polaris-Badge {
  background-color: #fff2d9;
  border-radius: 4px;
  padding: 3px 4px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-settings
  .set-rule-conditions
  .premium-badge-crown
  .Polaris-Badge
  img {
  width: 14px;
  height: auto;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .set-rule-strategies-title
  .Polaris-Icon {
  height: 0.8rem;
  width: 0.8rem;
  margin-top: 3px;
}
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-settings
  .summary-title
  .title {
  margin-left: 20px;
}
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-settings
  .summary-title {
  margin-left: -20px;
  margin-right: -20px;
}
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .set-rule-strategies-title
  .title {
  font-weight: 600;
  color: #6d7175;
}
.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .set-rule-strategies-title {
  display: flex;
  gap: 10px;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-body
  .merchandising-rule-settings
  .title-bold-normal {
  height: 56px;
  display: flex;
  align-items: center !important;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-preview {
  padding: 15px 15px 0 15px;
  width: 50%;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-preview .Polaris-Card {
  height: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-preview
  .Polaris-Card
  .Polaris-Card__Header {
  padding: 24px 0 0;
  border-bottom: 1px solid #f5f5f5;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-preview
  .Polaris-Card
  .Polaris-Card__Header
  > div {
  width: 100%;
  padding: 0 54px;
  text-align: center;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-preview
  .Polaris-Card
  .Polaris-Card__Header
  .Polaris-Heading {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0px -1px 0px #f5f5f5;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-preview
  .Polaris-Card
  .Polaris-Card__Section {
  padding: 0 54px;
}

.ABTesting__VariantAndTraffic-Merchandising .tooltip {
  margin-left: 7px;
  margin-top: 3px;
  width: 10px;
}

.ABTesting__VariantAndTraffic-Merchandising .tooltip .Polaris-Icon {
  width: 0.7rem;
  height: 0.7rem;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy .card-section:first-child {
  box-shadow: inset 0px -1px 0px #e1e3e5;
  display: flex;
  justify-content: space-between;
}

.ABTesting__VariantAndTraffic-Merchandising .render-queries-field {
  display: flex;
  justify-content: space-between;
}

.ABTesting__VariantAndTraffic-Merchandising .wrap-queries {
  margin-left: 10px;
}

.ABTesting__VariantAndTraffic-Merchandising .wrap-select {
  margin-left: 10px;
  display: flex;
}

.ABTesting__VariantAndTraffic-Merchandising .wrap-select .Polaris-Select-2 {
  margin-top: 0.75rem;
  width: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising .all-rule-note {
  margin-top: 4px;
  color: #6d7175;
}
.ABTesting__VariantAndTraffic-Merchandising .border-connect-select {
  width: 10px;
  height: 2rem;
  border-bottom: 1px solid #c9cccf;
  border-left: 1px solid #c9cccf;
}

.ABTesting__VariantAndTraffic-Merchandising .textfield-with-prefix {
  margin-top: 0.75rem;
}

.ABTesting__VariantAndTraffic-Merchandising .border-connect-input {
  width: 10px;
  height: 2rem;
  border-bottom: 1px solid #c9cccf;
}

.ABTesting__VariantAndTraffic-Merchandising .wrap-input .render-queries-field:not(:last-child) {
  border-left: 1px solid #c9cccf;
}

.ABTesting__VariantAndTraffic-Merchandising
  .wrap-input
  .render-queries-field:last-child
  .border-connect-input {
  border-left: 1px solid #c9cccf;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .card-section
  .default-text-style {
  font-weight: 400 !important;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Page
  .Polaris-Page-Header
  .Polaris-Page-Header__Row
  .Polaris-Page-Header__TitleWrapper {
  width: calc(100% - 350px);
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Page
  .Polaris-Page__Content
  .Polaris-Layout__Section--secondary
  .Polaris-Card
  form {
  --p-focused: none !important;
}

.ABTesting__VariantAndTraffic-Merchandising-DateRange {
  font-weight: normal;
  color: rgb(118, 118, 118);
}

.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout,
.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout .Polaris-Layout__Section,
.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Layout__Section
  .Polaris-Card__Section
  .Polaris-FormLayout {
  margin-top: 0;
}
.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Layout__Section--secondary
  .Polaris-Layout__Section
  .Polaris-Card__Section:first-child {
  margin-top: 20px;
}
.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Layout__Section--secondary
  .Polaris-Layout__Section
  .Polaris-Card__Section {
  margin-top: 21px;
}
.BC-Page__MerchandisingV2 .condition-scope {
  margin-bottom: 0.25rem;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Page
  .Polaris-Page__Content
  .Polaris-Layout
  .Polaris-Layout__Section {
  height: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Page
  .Polaris-Page__Content
  .Polaris-Layout
  .Polaris-Layout__Section
  .Polaris-Card
  .Polaris-Card__Header {
  height: 3.75rem;
  border-bottom: 1px solid rgb(233, 230, 230);
}
.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout {
  grid-auto-rows: 1fr;
  align-items: stretch;
  min-height: 800px;
}
.ABTesting__VariantAndTraffic-Merchandising .Polaris-Scrollable .Polaris-Layout,
.ABTesting__VariantAndTraffic-Merchandising .setting-rule-layout .Polaris-Layout {
  display: block !important;
  min-height: unset;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Scrollable
  .Polaris-Layout
  .Polaris-Layout__Section
  .Polaris-Card__Section
  .Polaris-Heading {
  font-size: 16px;
  line-height: 24px;
}

.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout .Polaris-Layout__Section .Polaris-Card {
  height: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Layout
  .Polaris-Layout__Section
  .Polaris-Card
  .Polaris-Layout
  .Polaris-Layout__Section
  .Polaris-Card__Section {
  padding: 0rem 1.25rem;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Layout
  .Polaris-Layout__Section
  .Polaris-Card
  .Polaris-Card__Header
  .Polaris-Heading {
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
}

.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout .Polaris-Layout__Section {
  width: 100%;
  height: inherit !important;
}
.ABTesting__VariantAndTraffic-Merchandising .conditions,
.ABTesting__VariantAndTraffic-Merchandising .conditions-detail {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.ABTesting__VariantAndTraffic-Merchandising .condition-hover-all-content {
  margin: 0rem -0.625rem -0.625rem -0.625rem;
  padding: 0.625rem 0.625rem 0.625rem 0.625rem;
}
.ABTesting__VariantAndTraffic-Merchandising .conditions-detail img {
  width: 1.375rem;
  height: 1.375rem;
  margin-right: 0.5rem;
}

.ABTesting__VariantAndTraffic-Merchandising .conditions-detail .Title_page_applied {
  color: gray;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.ABTesting__VariantAndTraffic-Merchandising .conditions .strategy-btn {
  width: 48%;
  padding: 0;
  margin-top: 1rem;
}
.ABTesting__VariantAndTraffic-Merchandising .conditions .strategy-btn button {
  width: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising .conditions .merchandising-lock-banner-btn button {
  background-color: #ffc96b;
  box-shadow: 0px -1px 0px 0px #00000033 inset;
  border: 0px;
}
.ABTesting__VariantAndTraffic-Merchandising .conditions button .Polaris-Button__Text {
  gap: 4px;
  display: flex;
  align-items: center;
}

.ABTesting__VariantAndTraffic-Merchandising .conditions .product-performance-ranking-btn {
  width: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising .conditions .Polaris-Button__Content,
.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Layout
  .Polaris-FormLayout__Item
  .Polaris-Button__Content
  .Polaris-Button__Text {
  font-weight: 500;
  line-height: 20px;
  font-size: 14px;
}
.ABTesting__VariantAndTraffic-Merchandising .conditions-detail p,
.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-content,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-content,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content {
  font-size: 14px !important;
  line-height: 20px;
}
.ABTesting__VariantAndTraffic-Merchandising .conditions-detail p span {
  font-weight: 600;
}

.ABTesting__VariantAndTraffic-Merchandising .consequence-add-button {
  position: absolute;
  top: '1px';
  right: 0;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail {
  margin: -0.625rem;
  padding: 0.625rem;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-settings .consequence-detail:hover {
  background-color: var(--p-surface-hovered);
  position: relative;
}

.AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .consequence-detail
  .consequence-detail-action,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail .consequence-detail-action {
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
  display: none;
}

.ABTesting__VariantAndTraffic-Merchandising .consequence-detail .consequence-detail-action button {
  margin-left: -0.25rem;
}

.ABTesting__VariantAndTraffic-Merchandising .consequence-detail:hover .consequence-detail-action {
  display: block;
}
.ABTesting__VariantAndTraffic-Merchandising .tile-set-condition .tooltip .Polaris-Icon {
  border: 0 !important;
  padding: 2px !important;
}
.ABTesting__VariantAndTraffic-Merchandising .tile-set-condition {
  display: flex;
  justify-content: space-between;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title-tooltip .Polaris-Icon,
.AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .consequence-detail-title-tooltip
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .consequence-detail-title-tooltip
  .Polaris-Icon {
  height: 0.75rem;
  width: 0.75rem;
  margin-top: 4px;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-header .title-header,
.AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .consequence-detail-header
  .title-header,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .consequence-detail-header
  .title-header {
  display: flex;
  align-items: center;
  gap: 4px;
}
.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-header,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-header,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .consequence-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px 16px 20px !important;
}

.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title,
.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title-tooltip,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title-tooltip,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .consequence-detail-title-tooltip {
  display: flex;
  gap: 10px;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title .title,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .title {
  display: inline-flex;
}

.BC-Page__ABTestingCampaignAnalytic
  .info
  .traffic
  .merchandising-rule-strategy
  .card-section:nth-child(3),
.consequence-detail-title
  .AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .merchandising-rule-strategy
  .card-section:nth-child(3)
  .consequence-detail-title,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .card-section:nth-child(3)
  .consequence-detail-title {
  margin-top: 6px;
}

.BC-Page__ABTestingCampaignAnalytic
  .info
  .traffic
  .merchandising-rule-strategy
  .card-section
  .consequence-detail-title,
.AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .merchandising-rule-strategy
  .card-section
  .consequence-detail-title,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .card-section
  .consequence-detail-title {
  margin-bottom: 14px;
  margin-top: 5px;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-draggable .wrap-attribute .card-section {
  border: 1px solid rgba(225, 227, 229, 1);
  border-radius: 8px;
  padding: unset !important;
  margin: 8px 0;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-draggable
  .consequence-detail-title
  .drag-icon
  .Polaris-Icon {
  border: unset !important;
  margin-right: 8px !important;
}

.ABTesting__VariantAndTraffic-Merchandising .merchandising-draggable .consequence-detail-title {
  border-bottom: 1px dashed rgba(225, 227, 229, 1);
  padding: 8px;
  margin: unset !important;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-draggable
  .consequence-detail-title
  .title {
  align-items: center;
  text-align: center;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-draggable
  .BC-MerchandisingV2__Attributes-Table
  > .Polaris-Stack {
  margin: unset;
  border-radius: unset;
}
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-draggable
  .consequence-detail-title
  .drag-icon
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-draggable
  .consequence-detail-title
  .drag-icon
  .Polaris-Icon
  svg {
  width: 24px !important;
  height: 24px !important;
}

.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-draggable
  .consequence-detail-title
  .title
  .group-number {
  padding: 2px 4px !important;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title .Polaris-Icon,
.AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .consequence-detail-title
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .consequence-detail-title
  .title
  .Polaris-Icon {
  border: solid 1px var(--p-icon-subdued);
  border-radius: 0.25rem;
  padding: 4px;
  margin-right: 0.5rem;
}

.BC-Page__ABTestingCampaignAnalytic
  .info
  .traffic
  .consequence-detail-title-banner
  .Polaris-Icon
  .AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .consequence-detail-title-banner
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title-banner .Polaris-Icon,
.merchandising-rule-strategy .consequence-detail-title .title-banner .Polaris-Icon {
  padding: 2px 4px !important;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title .Polaris-Icon,
.AB-Testing__ReviewMerchandisingCampaignModal
  .traffic
  .content
  .consequence-detail-title
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising
  .merchandising-rule-strategy
  .consequence-detail-title
  .title
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .title .Polaris-Icon {
  width: 1.375rem;
  height: 1.375rem;
}

.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content p {
  margin-top: 0.5rem;
}

.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content p:first-child,
.AB-Testing__ReviewMerchandisingCampaignModal .consequence-detail-content p:first-child,
.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content div:first-child {
  margin-top: 0.375rem;
}

.ABTesting__VariantAndTraffic-Merchandising
  .preview
  .productRow
  .productItem
  .product-image--no-image {
  background-color: #f4f6f8;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image,
.ABTesting__VariantAndTraffic-Merchandising .preview .productRow .productItem .product-image {
  position: relative;
  height: 193px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image {
  width: 100%;
  height: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a,
.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a,
.ABTesting__VariantAndTraffic-Merchandising .preview .productRow .productItem .product-image a {
  display: none;
}
.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image:hover
  a,
.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image:hover
  a,
.ABTesting__VariantAndTraffic-Merchandising
  .preview
  .productRow
  .productItem
  .product-image:hover
  a {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  > span,
.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  > span,
.ABTesting__VariantAndTraffic-Merchandising
  .preview
  .productRow
  .productItem
  .product-image
  a
  > span {
  position: absolute;
  bottom: 40%;
  right: 0;
  left: 0;
  text-align: center;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .Polaris-Icon,
.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising
  .preview
  .productRow
  .productItem
  .product-image
  a
  .Polaris-Icon {
  width: 1.5625rem;
  height: 1.5625rem;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .Polaris-Icon,
.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .Polaris-Icon,
.ABTesting__VariantAndTraffic-Merchandising
  .preview
  .productRow
  .productItem
  .product-image
  a
  .Polaris-Icon {
  fill: white;
}

.ABTesting__VariantAndTraffic-Merchandising
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .view-product,
.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  .product-image
  a
  .view-product,
.ABTesting__VariantAndTraffic-Merchandising
  .preview
  .productRow
  .productItem
  .product-image
  a
  .view-product {
  margin-top: 0.5rem;
  color: white;
  font-weight: 500;
}

.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  label,
.AB-Testing__ReviewMerchandisingCampaignModal
  .Polaris-Product-Tooltip-TooltipOverlay__Content
  label,
.ABTesting__VariantAndTraffic-Merchandising .Polaris-Product-Tooltip-TooltipOverlay__Content label {
  margin-top: 0.5rem;
  display: block;
}

.ABTesting__VariantAndTraffic-Merchandising .preview {
  font-size: 0.875rem;
  margin: 24px auto;
  max-width: 610px;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid {
  font-weight: 600;
  font-size: 1rem;
  margin: 0 0 1.25rem;
  width: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination {
  margin-top: -1.25rem;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .icon {
  border: 1px solid #c9cccf;
  border-radius: 6px;
  width: 26px;
  height: 26px;
  padding: 4px;
}
.ABTesting__VariantAndTraffic-Merchandising
  .preview
  .productGrid
  .pagination
  .icon:not(:last-child) {
  margin-right: 6px;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .disabled {
  background-color: #edeeef;
  opacity: 0.5;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .item {
  min-width: 24px;
  padding: 2px;
  text-align: center;
  border: 1px solid #c9cccf;
  border-radius: 6px;
  margin-right: 6px;
  font-weight: 400;
  font-size: 0.875rem;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .selected {
  background-color: #202123;
  color: #fff;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .link {
  cursor: pointer;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .point {
  border: none;
}

.ABTesting__VariantAndTraffic-Merchandising .pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  margin-bottom: 1.25rem;
  width: 100%;
}
.ABTesting__VariantAndTraffic-Merchandising .preview .noResult {
  margin-top: 2.5rem;
  text-align: center;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .noResult img {
  width: 50px;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .noResult .content {
  font-size: 1.25rem;
  padding-top: 1.25rem;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productRow {
  display: inline-flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
  width: 100%;
}
.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem {
  position: relative !important;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .pin {
  position: absolute;
  top: 10px;
  right: 6px;
  width: 0.8rem;
  z-index: 2;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem {
  width: 22%;
  margin-bottom: 20px;
  min-width: 100px;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .noImage {
  width: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .image {
  width: auto;
  height: auto;
  max-height: 193px;
  max-width: 100%;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .title {
  font-size: 14px;
  line-height: 20px;
  height: 45px;
  margin: 8px 0px;
  display: inline-block;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  line-height: 1.65;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .priceMin {
  color: #d72c0d;
}

.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .comparedAtPrice {
  color: #8c9196;
  text-decoration: line-through;
  margin-left: 5px;
}
.ABTesting__VariantAndTraffic-Merchandising .traffic-slider-wrapper {
  padding: 1rem 0;
}

.ABTesting__VariantAndTraffic-Merchandising .slider-container {
  margin: 16px 0;
}

.ABTesting__VariantAndTraffic-Merchandising .slider {
  width: 100%;
  height: 10px;
  border-radius: 1px;
  background: linear-gradient(to right, #3b82f6 50%, #fbbf24 50%);
  appearance: none;
  outline: none;
}

.ABTesting__VariantAndTraffic-Merchandising .slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 28px;
  background-color: #f1f2f3;
  border-radius: 2px;
  cursor: pointer;
  margin-top: -4px;
  /* Centered 6 circular dots */
  background-image: radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0);
  background-position: 3px 6px, 8px 6px, 3px 11px, 8px 11px, 3px 16px, 8px 16px;
  background-repeat: no-repeat;
  background-size: 4px 4px;
}

.ABTesting__VariantAndTraffic-Merchandising .slider::-moz-range-thumb {
  width: 14px;
  height: 28px;
  background-color: #f1f2f3;
  border-radius: 2px;
  cursor: pointer;
  background-image: radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0),
    radial-gradient(circle, #666 0.094rem, transparent 0);
  background-position: 4px 2px, 12px 2px, 4px 7px, 12px 7px, 4px 12px, 12px 12px;
  background-repeat: no-repeat;
  background-size: 4px 4px;
}

.ABTesting__VariantAndTraffic-Merchandising .inputs-container {
  margin-top: 16px;
  display: flex;
  gap: 50px;
}

.ABTesting__VariantAndTraffic-Merchandising .input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
  width: 50%;
}

.ABTesting__VariantAndTraffic-Merchandising .input-wrapper > div:first-child {
  display: flex;
  gap: 4px;
  align-items: center;
}

.BC-Page__ABTestingCampaignAnalytic .dot,
.AB-Testing__ReviewMerchandisingCampaignModal .dot,
.ABTesting__VariantAndTraffic-Merchandising .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.BC-Page__ABTestingCampaignAnalytic .row .dot.blue,
.BC-Page__ABTestingCampaignAnalytic .info .dot.blue,
.AB-Testing__ReviewMerchandisingCampaignModal .dot.blue,
.ABTesting__VariantAndTraffic-Merchandising .dot.blue {
  background-color: #1e9bd6;
}

.BC-Page__ABTestingCampaignAnalytic .row .dot.yellow,
.BC-Page__ABTestingCampaignAnalytic .info .dot.yellow,
.AB-Testing__ReviewMerchandisingCampaignModal .dot.yellow,
.ABTesting__VariantAndTraffic-Merchandising .dot.yellow {
  background-color: #f9b23a;
}

.AB-Testing__ReviewMerchandisingCampaignModal .Polaris-Heading {
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}

.AB-Testing__ReviewMerchandisingCampaignModal {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.AB-Testing__ReviewMerchandisingCampaignModal .info,
.AB-Testing__ReviewMerchandisingCampaignModal .name {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.AB-Testing__ReviewMerchandisingCampaignModal .info > span {
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic > div,
.AB-Testing__ReviewMerchandisingCampaignModal .info > div {
  display: flex;
  gap: 16px;
}
.BC-Page__ABTestingCampaignAnalytic .info .traffic .item,
.AB-Testing__ReviewMerchandisingCampaignModal .info .item {
  width: 50%;
}
.AB-Testing__ReviewMerchandisingCampaignModal .campaign .item {
  border: 1px solid #e1e3e5;
  border-radius: 4px;
  padding: 16px;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .yellow,
.BC-Page__ABTestingCampaignAnalytic .info .yellow .heading,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .yellow .heading {
  background-color: #fefbf5;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .blue,
.BC-Page__ABTestingCampaignAnalytic .info .blue .heading,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .blue .heading {
  background-color: #f4fafd;
}
.BC-Page__ABTestingCampaignAnalytic .info .traffic .item,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .item {
  border: 1px solid #e1e3e5;
  border-radius: 4px;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic .item .heading,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .item .heading {
  border-bottom: 1px solid #e1e3e5;
  display: flex;
  align-items: center;
  gap: 8px;
}
.BC-Page__ABTestingCampaignAnalytic .info .traffic .item > div,
.AB-Testing__ReviewMerchandisingCampaignModal .traffic .item > div {
  padding: 16px;
}

/* ------- end -> variant version */

/* ANALYTICS */

.BC-Page__ABTestingCampaignAnalytic .overview {
  padding: 20px;
  display: flex;
  gap: 16px;
}

.BC-Page__ABTestingCampaignAnalytic .overview .item {
  width: calc(100% - 16px);
  padding: 16px;
  background: #fafbfb;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.BC-Page__ABTestingCampaignAnalytic .info {
  padding: 20px;
}

.BC-Page__ABTestingCampaignAnalytic .info .traffic {
  margin-top: 16px;
}

.BC-Page__ABTestingCampaignAnalytic .info .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.BC-Page__ABTestingCampaignAnalytic .info .Polaris-Icon {
  margin: unset;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table {
  padding: 20px;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row {
  display: flex;
  width: 100%;
  border-top: 1px solid #e1e3e5;
  border-left: 1px solid #e1e3e5;
  border-right: 1px solid #e1e3e5;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .heading {
  font-weight: 500;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row:first-child {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row:last-child {
  border-bottom: 1px solid #e1e3e5;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row > div {
  padding: 20px;
}

.BC-Page__ABTestingCampaignAnalytic .BC-chart .Polaris-Heading {
  border: unset;
}

.BC-Page__ABTestingCampaignAnalytic .Polaris-Layout__Section {
  margin-top: 24px;
}

.BC-Page__ABTestingCampaignAnalytic .test-detail-table .badge-winner {
  display: flex;
  align-items: center;
  gap: 2px;
  color: #008060;
  background-color: #e2f1ea;
  padding: 2px 4px;
  font-weight: 600;
  font-size: 12px;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ab-testing.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;EACpD,uDAAuD;AACzD;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA,wBAAwB;;AAExB,qCAAqC;AACrC;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;AACR;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;EAME,aAAa;EACb,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;AACf;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;;;EAKE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;;;;;EAKE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;EAIE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;;;;EAKE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;;;EAKE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;EAIE,aAAa;EACb,QAAQ;AACV;;AAEA;;;;;EAKE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;;;;;EAKE,iBAAiB;AACnB;AACA;;;;EAIE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;EAIE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;;;;EAKE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;EAKE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,aAAa;AACf;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;;;;EAOE,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;;;;EAME,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,WAAW;AACb;AACA;EACE,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;EAME,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;;;;EAIE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;;;;;;EAME,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;;;;;;;;EAUE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;;;;EAKE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;;;;;;EAME,aAAa;EACb,SAAS;AACX;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;EAgBE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;EAgBE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;;;EAKE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,oBAAoB;AACtB;AACA;;;;;;;;;;;EAWE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;EAYE,uCAAuC;EACvC,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;EAaE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;EAIE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;EASE,aAAa;AACf;AACA;;;;;;;;;;;;;;EAcE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,yEAAyE;AAC3E;;AAEA;;;;;;;;;;;;;;;;;EAiBE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;EAiBE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;EAiBE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;EAiBE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+DAA+D;EAC/D,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B;;;;;yDAKuD;EACvD,6EAA6E;EAC7E,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf;;;;;yDAKuD;EACvD,8EAA8E;EAC9E,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,aAAa;AACf;;AAEA,mCAAmC;;AAEnC,cAAc;;AAEd;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".BC-Page__ABTestingCampaignManagement .BC-Filters .BC-Filters-ConnectedFilterControl {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: 0.75rem;\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__ABTestingCampaignManagement .BC-Filters .Polaris-Tabs__Wrapper {\n  border-bottom: none;\n}\n\n.BC-Page__ABTestingCampaignManagement .BC-Filters .search {\n  width: 300px;\n}\n\n.BC-Page__ABTestingCampaignManagement .BC-Filters-ConnectedFilterControl__LeftContainer {\n  flex: 1 1 auto;\n}\n\n.BC-Page__ABTestingCampaignManagement\n  .BC-Filters-ConnectedFilterControl__LeftContainer\n  .Polaris-Tabs__Wrapper\n  #none {\n  display: none;\n}\n\n.BC-Page__ABTestingCampaignManagement .BC-Filters-ConnectedFilterControl__RightContainer {\n  flex: 2 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.BC-EmptySearch__ABTestingCampaign > p {\n  color: #6d7175;\n}\n\n.ab-testing-campaign-table .feature-type {\n  display: flex;\n  padding: 1rem 0;\n  cursor: pointer;\n}\n\n.ab-testing-campaign-table .feature-type-title {\n  font-weight: 600;\n  display: flex;\n}\n\n.ab-testing-campaign-table .feature-type-title .Polaris-Icon {\n  margin: 0 0.5rem 0 0.25rem;\n}\n\n.ab-testing-campaign-table thead {\n  background: var(--surface-subdued, #fafbfb);\n}\n\n.ab-testing-campaign-table thead tr td:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-left: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.ab-testing-campaign-table thead tr td {\n  border-top: 1px solid var(--border-divider, #e1e3e5);\n  border-bottom: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.ab-testing-campaign-table thead tr td:last-child {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-right: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.ab-testing-campaign-table .Polaris-DataTable__Cell > p {\n  word-break: break-all;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n\n.BC-Page__ABTestingCampaignManagement .pfs-feature-lock-card {\n  padding-bottom: 50px;\n}\n\n.ab-testing-campaign-table .Polaris-DataTable__Cell--status,\n.ab-testing-campaign-table .Polaris-DataTable__Cell--views {\n  text-align: center;\n}\n\n.ab-testing-campaign-table .Polaris-DataTable__Cell--actions .btn-launch button {\n  color: var(--p-action-primary);\n  border-color: var(--p-action-primary);\n}\n\n.ab-testing-campaign-table .Polaris-DataTable__Cell--actions .Polaris-Icon svg {\n  fill: var(--p-icon);\n}\n\n.BC-AB-testing-tour .image {\n  background-color: #f7fdfc;\n}\n\n.BC-AB-testing-tour .image img {\n  width: auto;\n  height: 200px;\n  padding: 16px;\n}\n\n.BC-AB-testing-tour .image {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-AB-testing-tour .action-tour {\n  display: flex;\n  justify-content: end;\n  padding: 0 16px 16px;\n}\n\n.BC-AB-testing-tour .heading-tour {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* AB testing - add new merchandising campaign */\n.ABTesting-Campaign__GeneralSettings .settings {\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n}\n\n.ABTesting-Campaign__GeneralSettings .settings .content button .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  width: 15px;\n  height: 15px;\n}\n\n.ABTesting-Campaign__GeneralSettings .settings .content {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ABTesting-Campaign__GeneralSettings .targeting-settings {\n  display: flex;\n  flex: 1 1 auto;\n  gap: 12px;\n}\n\n.ABTesting-Campaign__GeneralSettings .targeting-settings > div:first-child {\n  width: 30%;\n}\n\n.ABTesting-Campaign__GeneralSettings .targeting-settings > div:last-child {\n  width: 70%;\n}\n\n.ABTesting-Campaign__GeneralSettings .targeting-settings .Polaris-Tag {\n  padding-right: unset;\n}\n\n.ABTesting-Campaign__GeneralSettings .Polaris-ChoiceList__Choices {\n  display: flex;\n  flex: 1 auto;\n  gap: 32px;\n}\n\n/* Variant and traffic */\n\n/* ------- variant version--------- */\n.ABTesting__VariantAndTraffic-Merchandising .config-sidebar {\n  background: #ffffff;\n  width: 25%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading {\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .Polaris-Icon {\n  margin: unset;\n}\n.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .title {\n  font-size: 16px;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .title > p {\n  font-weight: 600;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .collapse-section .heading .title .point {\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .config-sidebar > div {\n  border-bottom: 1px solid #e1e3e5;\n  padding: 16px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .config-sidebar .variants {\n  padding: unset;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .config-sidebar .variants .heading {\n  padding: 16px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .config-sidebar .variants .card-section {\n  padding: 0 16px 16px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy > div {\n  min-height: 1000px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-FullscreenBar {\n  position: fixed;\n  width: 100%;\n  top: 0;\n}\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body {\n  display: flex;\n  justify-content: space-between;\n  height: 100vh;\n  min-height: 1040px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .strategy-content {\n  margin: 0 10px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .banner-group-settings {\n  padding: 10px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .strategy-content\n  .card-section {\n  padding: 0px 20px 5px 0px;\n  width: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .card-banner-section\n  > div\n  > div {\n  display: grid;\n  gap: 20px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .card-section {\n  padding: 0 !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-title {\n  margin-top: 0px;\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-title .title {\n  display: flex;\n  gap: 3px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6d7175;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-settings {\n  padding: 12px;\n  border-radius: 8px;\n  background-color: #f6f6f7;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-image .Polaris-Link {\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n  align-items: center;\n  margin-top: 5px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .banner-group-settings\n  .banner-image\n  .Polaris-Link\n  .Polaris-Icon {\n  margin: unset;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .banner-group-settings\n  .banner-settings\n  > div:not(:first-child) {\n  margin-top: 16px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .banner-group-settings .banner-image > p:last-child {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 5px;\n  color: #6d7175;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .merchandising-strategies {\n  margin-top: 15px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy {\n  background-color: #ffffff;\n  width: 30%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy .card-section {\n  padding: 16px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .Polaris-Tabs__TabContainer {\n  flex: unset;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .card-section:last-child,\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .card-section:last-child {\n  box-shadow: unset;\n}\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .card-section > p {\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 2px;\n  margin-bottom: 1px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .wrap-attribute {\n  display: flex;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .last-or-connector {\n  border-bottom: 1px solid #a4e8f2;\n  margin-bottom: 30px;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .or-text\n  .Polaris-TextStyle--variationStrong {\n  height: 20px;\n  padding-left: 5px;\n  padding-right: 5px;\n  border-radius: 10px;\n  background-color: #a4e8f2;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .group-number {\n  width: auto;\n  min-width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid rgba(201, 204, 207, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 5px;\n  font-size: 12px;\n  color: rgba(109, 113, 117, 1);\n  line-height: 16px;\n  font-weight: 500;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .or-connector {\n  width: 10px;\n  margin-left: 10px;\n  border-left: 1px solid #a4e8f2;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .wrap-attribute\n  .first-connector {\n  border-top: 1px solid #a4e8f2;\n  margin-top: 15px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-strategy\n  .card-add-field-attribute\n  .or-connector {\n  border-bottom: 1px solid #a4e8f2;\n  margin-bottom: 20px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-settings .set-rule-conditions > div,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-settings\n  .set-rule-conditions\n  > div {\n  padding-top: 16px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-settings\n  .set-rule-conditions\n  .default-text-style {\n  font-weight: 400 !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-settings\n  .set-rule-conditions\n  .premium-badge-crown {\n  display: flex;\n  gap: 4px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-settings\n  .set-rule-conditions\n  .premium-badge-crown\n  .Polaris-Badge {\n  background-color: #fff2d9;\n  border-radius: 4px;\n  padding: 3px 4px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-settings\n  .set-rule-conditions\n  .premium-badge-crown\n  .Polaris-Badge\n  img {\n  width: 14px;\n  height: auto;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .set-rule-strategies-title\n  .Polaris-Icon {\n  height: 0.8rem;\n  width: 0.8rem;\n  margin-top: 3px;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-settings\n  .summary-title\n  .title {\n  margin-left: 20px;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-settings\n  .summary-title {\n  margin-left: -20px;\n  margin-right: -20px;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .set-rule-strategies-title\n  .title {\n  font-weight: 600;\n  color: #6d7175;\n}\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-body .set-rule-strategies-title {\n  display: flex;\n  gap: 10px;\n  font-weight: 400;\n  font-size: 14px;\n  align-items: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-body\n  .merchandising-rule-settings\n  .title-bold-normal {\n  height: 56px;\n  display: flex;\n  align-items: center !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-preview {\n  padding: 15px 15px 0 15px;\n  width: 50%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-preview .Polaris-Card {\n  height: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-preview\n  .Polaris-Card\n  .Polaris-Card__Header {\n  padding: 24px 0 0;\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-preview\n  .Polaris-Card\n  .Polaris-Card__Header\n  > div {\n  width: 100%;\n  padding: 0 54px;\n  text-align: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-preview\n  .Polaris-Card\n  .Polaris-Card__Header\n  .Polaris-Heading {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset 0px -1px 0px #f5f5f5;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-preview\n  .Polaris-Card\n  .Polaris-Card__Section {\n  padding: 0 54px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .tooltip {\n  margin-left: 7px;\n  margin-top: 3px;\n  width: 10px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .tooltip .Polaris-Icon {\n  width: 0.7rem;\n  height: 0.7rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-strategy .card-section:first-child {\n  box-shadow: inset 0px -1px 0px #e1e3e5;\n  display: flex;\n  justify-content: space-between;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .render-queries-field {\n  display: flex;\n  justify-content: space-between;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .wrap-queries {\n  margin-left: 10px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .wrap-select {\n  margin-left: 10px;\n  display: flex;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .wrap-select .Polaris-Select-2 {\n  margin-top: 0.75rem;\n  width: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .all-rule-note {\n  margin-top: 4px;\n  color: #6d7175;\n}\n.ABTesting__VariantAndTraffic-Merchandising .border-connect-select {\n  width: 10px;\n  height: 2rem;\n  border-bottom: 1px solid #c9cccf;\n  border-left: 1px solid #c9cccf;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .textfield-with-prefix {\n  margin-top: 0.75rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .border-connect-input {\n  width: 10px;\n  height: 2rem;\n  border-bottom: 1px solid #c9cccf;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .wrap-input .render-queries-field:not(:last-child) {\n  border-left: 1px solid #c9cccf;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .wrap-input\n  .render-queries-field:last-child\n  .border-connect-input {\n  border-left: 1px solid #c9cccf;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .card-section\n  .default-text-style {\n  font-weight: 400 !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Page\n  .Polaris-Page-Header\n  .Polaris-Page-Header__Row\n  .Polaris-Page-Header__TitleWrapper {\n  width: calc(100% - 350px);\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Page\n  .Polaris-Page__Content\n  .Polaris-Layout__Section--secondary\n  .Polaris-Card\n  form {\n  --p-focused: none !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising-DateRange {\n  font-weight: normal;\n  color: rgb(118, 118, 118);\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout,\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout .Polaris-Layout__Section,\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Layout__Section\n  .Polaris-Card__Section\n  .Polaris-FormLayout {\n  margin-top: 0;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Layout__Section--secondary\n  .Polaris-Layout__Section\n  .Polaris-Card__Section:first-child {\n  margin-top: 20px;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Layout__Section--secondary\n  .Polaris-Layout__Section\n  .Polaris-Card__Section {\n  margin-top: 21px;\n}\n.BC-Page__MerchandisingV2 .condition-scope {\n  margin-bottom: 0.25rem;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Page\n  .Polaris-Page__Content\n  .Polaris-Layout\n  .Polaris-Layout__Section {\n  height: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Page\n  .Polaris-Page__Content\n  .Polaris-Layout\n  .Polaris-Layout__Section\n  .Polaris-Card\n  .Polaris-Card__Header {\n  height: 3.75rem;\n  border-bottom: 1px solid rgb(233, 230, 230);\n}\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout {\n  grid-auto-rows: 1fr;\n  align-items: stretch;\n  min-height: 800px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-Scrollable .Polaris-Layout,\n.ABTesting__VariantAndTraffic-Merchandising .setting-rule-layout .Polaris-Layout {\n  display: block !important;\n  min-height: unset;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Scrollable\n  .Polaris-Layout\n  .Polaris-Layout__Section\n  .Polaris-Card__Section\n  .Polaris-Heading {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout .Polaris-Layout__Section .Polaris-Card {\n  height: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Layout\n  .Polaris-Layout__Section\n  .Polaris-Card\n  .Polaris-Layout\n  .Polaris-Layout__Section\n  .Polaris-Card__Section {\n  padding: 0rem 1.25rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Layout\n  .Polaris-Layout__Section\n  .Polaris-Card\n  .Polaris-Card__Header\n  .Polaris-Heading {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 28px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-Layout .Polaris-Layout__Section {\n  width: 100%;\n  height: inherit !important;\n}\n.ABTesting__VariantAndTraffic-Merchandising .conditions,\n.ABTesting__VariantAndTraffic-Merchandising .conditions-detail {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.ABTesting__VariantAndTraffic-Merchandising .condition-hover-all-content {\n  margin: 0rem -0.625rem -0.625rem -0.625rem;\n  padding: 0.625rem 0.625rem 0.625rem 0.625rem;\n}\n.ABTesting__VariantAndTraffic-Merchandising .conditions-detail img {\n  width: 1.375rem;\n  height: 1.375rem;\n  margin-right: 0.5rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .conditions-detail .Title_page_applied {\n  color: gray;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .conditions .strategy-btn {\n  width: 48%;\n  padding: 0;\n  margin-top: 1rem;\n}\n.ABTesting__VariantAndTraffic-Merchandising .conditions .strategy-btn button {\n  width: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .conditions .merchandising-lock-banner-btn button {\n  background-color: #ffc96b;\n  box-shadow: 0px -1px 0px 0px #00000033 inset;\n  border: 0px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .conditions button .Polaris-Button__Text {\n  gap: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .conditions .product-performance-ranking-btn {\n  width: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .conditions .Polaris-Button__Content,\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Layout\n  .Polaris-FormLayout__Item\n  .Polaris-Button__Content\n  .Polaris-Button__Text {\n  font-weight: 500;\n  line-height: 20px;\n  font-size: 14px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .conditions-detail p,\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-content,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-content,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content {\n  font-size: 14px !important;\n  line-height: 20px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .conditions-detail p span {\n  font-weight: 600;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .consequence-add-button {\n  position: absolute;\n  top: '1px';\n  right: 0;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail {\n  margin: -0.625rem;\n  padding: 0.625rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-rule-settings .consequence-detail:hover {\n  background-color: var(--p-surface-hovered);\n  position: relative;\n}\n\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .consequence-detail\n  .consequence-detail-action,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail .consequence-detail-action {\n  position: absolute;\n  top: 0.625rem;\n  right: 0.625rem;\n  display: none;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail .consequence-detail-action button {\n  margin-left: -0.25rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail:hover .consequence-detail-action {\n  display: block;\n}\n.ABTesting__VariantAndTraffic-Merchandising .tile-set-condition .tooltip .Polaris-Icon {\n  border: 0 !important;\n  padding: 2px !important;\n}\n.ABTesting__VariantAndTraffic-Merchandising .tile-set-condition {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title-tooltip .Polaris-Icon,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .consequence-detail-title-tooltip\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .consequence-detail-title-tooltip\n  .Polaris-Icon {\n  height: 0.75rem;\n  width: 0.75rem;\n  margin-top: 4px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-header .title-header,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .consequence-detail-header\n  .title-header,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .consequence-detail-header\n  .title-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-header,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-header,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .consequence-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px 16px 20px !important;\n}\n\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title,\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title-tooltip,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title-tooltip,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .consequence-detail-title-tooltip {\n  display: flex;\n  gap: 10px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .content .consequence-detail-title .title,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .title {\n  display: inline-flex;\n}\n\n.BC-Page__ABTestingCampaignAnalytic\n  .info\n  .traffic\n  .merchandising-rule-strategy\n  .card-section:nth-child(3),\n.consequence-detail-title\n  .AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .merchandising-rule-strategy\n  .card-section:nth-child(3)\n  .consequence-detail-title,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .card-section:nth-child(3)\n  .consequence-detail-title {\n  margin-top: 6px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic\n  .info\n  .traffic\n  .merchandising-rule-strategy\n  .card-section\n  .consequence-detail-title,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .merchandising-rule-strategy\n  .card-section\n  .consequence-detail-title,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .card-section\n  .consequence-detail-title {\n  margin-bottom: 14px;\n  margin-top: 5px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-draggable .wrap-attribute .card-section {\n  border: 1px solid rgba(225, 227, 229, 1);\n  border-radius: 8px;\n  padding: unset !important;\n  margin: 8px 0;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-draggable\n  .consequence-detail-title\n  .drag-icon\n  .Polaris-Icon {\n  border: unset !important;\n  margin-right: 8px !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .merchandising-draggable .consequence-detail-title {\n  border-bottom: 1px dashed rgba(225, 227, 229, 1);\n  padding: 8px;\n  margin: unset !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-draggable\n  .consequence-detail-title\n  .title {\n  align-items: center;\n  text-align: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-draggable\n  .BC-MerchandisingV2__Attributes-Table\n  > .Polaris-Stack {\n  margin: unset;\n  border-radius: unset;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-draggable\n  .consequence-detail-title\n  .drag-icon\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-draggable\n  .consequence-detail-title\n  .drag-icon\n  .Polaris-Icon\n  svg {\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-draggable\n  .consequence-detail-title\n  .title\n  .group-number {\n  padding: 2px 4px !important;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title .Polaris-Icon,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .consequence-detail-title\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .consequence-detail-title\n  .title\n  .Polaris-Icon {\n  border: solid 1px var(--p-icon-subdued);\n  border-radius: 0.25rem;\n  padding: 4px;\n  margin-right: 0.5rem;\n}\n\n.BC-Page__ABTestingCampaignAnalytic\n  .info\n  .traffic\n  .consequence-detail-title-banner\n  .Polaris-Icon\n  .AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .consequence-detail-title-banner\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title-banner .Polaris-Icon,\n.merchandising-rule-strategy .consequence-detail-title .title-banner .Polaris-Icon {\n  padding: 2px 4px !important;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .consequence-detail-title .Polaris-Icon,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .traffic\n  .content\n  .consequence-detail-title\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising\n  .merchandising-rule-strategy\n  .consequence-detail-title\n  .title\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-title .title .Polaris-Icon {\n  width: 1.375rem;\n  height: 1.375rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content p {\n  margin-top: 0.5rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content p:first-child,\n.AB-Testing__ReviewMerchandisingCampaignModal .consequence-detail-content p:first-child,\n.ABTesting__VariantAndTraffic-Merchandising .consequence-detail-content div:first-child {\n  margin-top: 0.375rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .preview\n  .productRow\n  .productItem\n  .product-image--no-image {\n  background-color: #f4f6f8;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image,\n.ABTesting__VariantAndTraffic-Merchandising .preview .productRow .productItem .product-image {\n  position: relative;\n  height: 193px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image {\n  width: 100%;\n  height: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a,\n.ABTesting__VariantAndTraffic-Merchandising .preview .productRow .productItem .product-image a {\n  display: none;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image:hover\n  a,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image:hover\n  a,\n.ABTesting__VariantAndTraffic-Merchandising\n  .preview\n  .productRow\n  .productItem\n  .product-image:hover\n  a {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  > span,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  > span,\n.ABTesting__VariantAndTraffic-Merchandising\n  .preview\n  .productRow\n  .productItem\n  .product-image\n  a\n  > span {\n  position: absolute;\n  bottom: 40%;\n  right: 0;\n  left: 0;\n  text-align: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .Polaris-Icon,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising\n  .preview\n  .productRow\n  .productItem\n  .product-image\n  a\n  .Polaris-Icon {\n  width: 1.5625rem;\n  height: 1.5625rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .Polaris-Icon,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .Polaris-Icon,\n.ABTesting__VariantAndTraffic-Merchandising\n  .preview\n  .productRow\n  .productItem\n  .product-image\n  a\n  .Polaris-Icon {\n  fill: white;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .view-product,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  .product-image\n  a\n  .view-product,\n.ABTesting__VariantAndTraffic-Merchandising\n  .preview\n  .productRow\n  .productItem\n  .product-image\n  a\n  .view-product {\n  margin-top: 0.5rem;\n  color: white;\n  font-weight: 500;\n}\n\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  label,\n.AB-Testing__ReviewMerchandisingCampaignModal\n  .Polaris-Product-Tooltip-TooltipOverlay__Content\n  label,\n.ABTesting__VariantAndTraffic-Merchandising .Polaris-Product-Tooltip-TooltipOverlay__Content label {\n  margin-top: 0.5rem;\n  display: block;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview {\n  font-size: 0.875rem;\n  margin: 24px auto;\n  max-width: 610px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid {\n  font-weight: 600;\n  font-size: 1rem;\n  margin: 0 0 1.25rem;\n  width: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination {\n  margin-top: -1.25rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .icon {\n  border: 1px solid #c9cccf;\n  border-radius: 6px;\n  width: 26px;\n  height: 26px;\n  padding: 4px;\n}\n.ABTesting__VariantAndTraffic-Merchandising\n  .preview\n  .productGrid\n  .pagination\n  .icon:not(:last-child) {\n  margin-right: 6px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .disabled {\n  background-color: #edeeef;\n  opacity: 0.5;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .item {\n  min-width: 24px;\n  padding: 2px;\n  text-align: center;\n  border: 1px solid #c9cccf;\n  border-radius: 6px;\n  margin-right: 6px;\n  font-weight: 400;\n  font-size: 0.875rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .selected {\n  background-color: #202123;\n  color: #fff;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .link {\n  cursor: pointer;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productGrid .pagination .point {\n  border: none;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .pagination {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  margin-bottom: 1.25rem;\n  width: 100%;\n}\n.ABTesting__VariantAndTraffic-Merchandising .preview .noResult {\n  margin-top: 2.5rem;\n  text-align: center;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .noResult img {\n  width: 50px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .noResult .content {\n  font-size: 1.25rem;\n  padding-top: 1.25rem;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productRow {\n  display: inline-flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 1.25rem;\n  width: 100%;\n}\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem {\n  position: relative !important;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .pin {\n  position: absolute;\n  top: 10px;\n  right: 6px;\n  width: 0.8rem;\n  z-index: 2;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem {\n  width: 22%;\n  margin-bottom: 20px;\n  min-width: 100px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .noImage {\n  width: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .image {\n  width: auto;\n  height: auto;\n  max-height: 193px;\n  max-width: 100%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .title {\n  font-size: 14px;\n  line-height: 20px;\n  height: 45px;\n  margin: 8px 0px;\n  display: inline-block;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n  line-height: 1.65;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .priceMin {\n  color: #d72c0d;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .preview .productList .productItem .comparedAtPrice {\n  color: #8c9196;\n  text-decoration: line-through;\n  margin-left: 5px;\n}\n.ABTesting__VariantAndTraffic-Merchandising .traffic-slider-wrapper {\n  padding: 1rem 0;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .slider-container {\n  margin: 16px 0;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .slider {\n  width: 100%;\n  height: 10px;\n  border-radius: 1px;\n  background: linear-gradient(to right, #3b82f6 50%, #fbbf24 50%);\n  appearance: none;\n  outline: none;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 14px;\n  height: 28px;\n  background-color: #f1f2f3;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-top: -4px;\n  /* Centered 6 circular dots */\n  background-image: radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0);\n  background-position: 3px 6px, 8px 6px, 3px 11px, 8px 11px, 3px 16px, 8px 16px;\n  background-repeat: no-repeat;\n  background-size: 4px 4px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .slider::-moz-range-thumb {\n  width: 14px;\n  height: 28px;\n  background-color: #f1f2f3;\n  border-radius: 2px;\n  cursor: pointer;\n  background-image: radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0),\n    radial-gradient(circle, #666 0.094rem, transparent 0);\n  background-position: 4px 2px, 12px 2px, 4px 7px, 12px 7px, 4px 12px, 12px 12px;\n  background-repeat: no-repeat;\n  background-size: 4px 4px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .inputs-container {\n  margin-top: 16px;\n  display: flex;\n  gap: 50px;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .input-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  justify-content: space-between;\n  width: 50%;\n}\n\n.ABTesting__VariantAndTraffic-Merchandising .input-wrapper > div:first-child {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .dot,\n.AB-Testing__ReviewMerchandisingCampaignModal .dot,\n.ABTesting__VariantAndTraffic-Merchandising .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .row .dot.blue,\n.BC-Page__ABTestingCampaignAnalytic .info .dot.blue,\n.AB-Testing__ReviewMerchandisingCampaignModal .dot.blue,\n.ABTesting__VariantAndTraffic-Merchandising .dot.blue {\n  background-color: #1e9bd6;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .row .dot.yellow,\n.BC-Page__ABTestingCampaignAnalytic .info .dot.yellow,\n.AB-Testing__ReviewMerchandisingCampaignModal .dot.yellow,\n.ABTesting__VariantAndTraffic-Merchandising .dot.yellow {\n  background-color: #f9b23a;\n}\n\n.AB-Testing__ReviewMerchandisingCampaignModal .Polaris-Heading {\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 600;\n}\n\n.AB-Testing__ReviewMerchandisingCampaignModal {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.AB-Testing__ReviewMerchandisingCampaignModal .info,\n.AB-Testing__ReviewMerchandisingCampaignModal .name {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.AB-Testing__ReviewMerchandisingCampaignModal .info > span {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic > div,\n.AB-Testing__ReviewMerchandisingCampaignModal .info > div {\n  display: flex;\n  gap: 16px;\n}\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .item,\n.AB-Testing__ReviewMerchandisingCampaignModal .info .item {\n  width: 50%;\n}\n.AB-Testing__ReviewMerchandisingCampaignModal .campaign .item {\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n  padding: 16px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .yellow,\n.BC-Page__ABTestingCampaignAnalytic .info .yellow .heading,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .yellow .heading {\n  background-color: #fefbf5;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .blue,\n.BC-Page__ABTestingCampaignAnalytic .info .blue .heading,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .blue .heading {\n  background-color: #f4fafd;\n}\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .item,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .item {\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .item .heading,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .item .heading {\n  border-bottom: 1px solid #e1e3e5;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.BC-Page__ABTestingCampaignAnalytic .info .traffic .item > div,\n.AB-Testing__ReviewMerchandisingCampaignModal .traffic .item > div {\n  padding: 16px;\n}\n\n/* ------- end -> variant version */\n\n/* ANALYTICS */\n\n.BC-Page__ABTestingCampaignAnalytic .overview {\n  padding: 20px;\n  display: flex;\n  gap: 16px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .overview .item {\n  width: calc(100% - 16px);\n  padding: 16px;\n  background: #fafbfb;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info {\n  padding: 20px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .traffic {\n  margin-top: 16px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .info .Polaris-Icon {\n  margin: unset;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table {\n  padding: 20px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row {\n  display: flex;\n  width: 100%;\n  border-top: 1px solid #e1e3e5;\n  border-left: 1px solid #e1e3e5;\n  border-right: 1px solid #e1e3e5;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .heading {\n  font-weight: 500;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row:first-child {\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row:last-child {\n  border-bottom: 1px solid #e1e3e5;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .row > div {\n  padding: 20px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .BC-chart .Polaris-Heading {\n  border: unset;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .Polaris-Layout__Section {\n  margin-top: 24px;\n}\n\n.BC-Page__ABTestingCampaignAnalytic .test-detail-table .badge-winner {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  color: #008060;\n  background-color: #e2f1ea;\n  padding: 2px 4px;\n  font-weight: 600;\n  font-size: 12px;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
